export default "__VITE_ASSET__a84c8b0d__"